import { css } from "@emotion/css";
import { ShadowType, Spacing } from "@snapchat/snap-design-system";

export const apiCardContainer = css`
    margin-top: 0;
    box-shadow: ${ShadowType.REGULAR};
`;

export const loadableContainer = css`
    width: 100%;
    padding: ${Spacing.LG}px ${Spacing.LG}px;
`;
